import React from "react";
import { Stack } from "@chakra-ui/react";
import { useStaticQuery, graphql } from "gatsby";
import { Helmet } from "react-helmet";

import AppBar from "../ui/mainPage/AppBar";
import Footer from "../ui/mainPage/Footer";

const Layout = (props) => {
  const {
    children,
    refs,
    main,
    title = "microPublication - Get Your Data Out, Be Cited",
  } = props;

  const data = useStaticQuery(graphql`
    query LunrIndex {
      allIndex {
        nodes {
          internal {
            content
          }
        }
      }
    }
  `);

  const lunrIndex = JSON.parse(data.allIndex.nodes[0].internal.content);

  return (
    <>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      <Stack>
        <AppBar lunrIndex={lunrIndex} refs={refs} main={main} />
        {children}
        <Footer />
      </Stack>
    </>
  );
};

export default Layout;
